import React from 'react';
import styled from 'styled-components';
import { Button } from '@ubeya/shared-web/components';
import { ReactComponent as BasePlusIcon } from '@ubeya/shared-web/assets/plus.svg';

const Link = styled(Button).attrs(() => ({ link: true, type: 'button' }))``;

const PlusIcon = styled(BasePlusIcon)`
  margin-right: 3px;
  width: 10px;
  height: 10px;
  > path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;

const AddLink = ({ children, onClick }) => (
  <Link onClick={onClick}>
    <PlusIcon />
    {children}
  </Link>
);

export default AddLink;
